import * as R from 'ramda';
import crd from 'country-region-data';

/**
 * @typedef Region
 * @type {object}
 * @param {string} name
 * @param {string} shortCode
 */

/**
 * @typedef CountryRegionDatum
 * @type {object}
 * @param {string} countryName
 * @param {string} countryShortCode
 * @param {Array<Region>} regions
 */

/** @type Array<CountryRegionDatum> */
const CountryRegionData = crd;

export const CountryMap = R.pipe(
    R.map(({countryShortCode, countryName}) => ({
        [R.toLower(countryShortCode)]: countryName
    })),
    R.mergeAll
)(CountryRegionData);

export const CountryOptionsList = R.pipe(
    R.map(({countryShortCode, countryName}) => ({
        value: R.toLower(countryShortCode),
        label: countryName
    }))
)(CountryRegionData);

export function StateOptionsList(countries) {
    const _countries = countries || [];
    return R.pipe(
        R.filter(country => _countries.includes(R.toLower(country.countryShortCode))),
        R.map(co => R.prop('regions', co)),
        R.flatten,
        R.filter(R.prop('shortCode')),
        R.map(({shortCode, name}) => ({
            value: R.toLower(shortCode),
            label: name
        }))
    )(CountryRegionData);
}

export const RegionsByCountryShortCode = R.pipe(
    R.map(({countryShortCode, regions}) => ({
        [R.toLower(countryShortCode)]: R.pipe(
            R.reject(({shortCode}) => R.isNil(shortCode)),
            R.map(({shortCode, name}) => ({[R.toLower(shortCode)]: name})),
            R.mergeAll
        )(regions)
    })),
    R.mergeAll
)(CountryRegionData);

export default CountryRegionData;



// WEBPACK FOOTER //
// ./country_region_helper/index.js